import { createAxiosInstance } from '../helpers/api.helper';

export const createOrganisation = async (name, members) => {
    const request = await createAxiosInstance();

    return request({
        url: '/organisation/create',
        method: 'POST',
        data: {
            name,
            members
        }
    })
}

export const getUserOrganisation = async () => {
    const request = await createAxiosInstance();

    return request({
        url: `/organisation`,
        method: 'GET'
    })
}

export const getOrganisationMembers = async (id, page, nameFilter) => {
    const request = await createAxiosInstance();

    return request({
        url: `/organisation/members/${id}/${page}/${nameFilter}`,
        method: 'GET'
    })
}

export const updateUserRole = async (organisationId, userId, role) => {
    const request = await createAxiosInstance();

    return request({
        url: `/organisation/member/role`,
        method: 'POST',
        data: {
            organisation_id: organisationId,
            user_id: userId,
            role
        }
    })
}

export const inviteMembers = async (members) => {
    const request = await createAxiosInstance();

    return request({
        url: `/organisation/member/invite`,
        method: 'POST',
        data: {
            members
        }
    })
}

export const removeOrganisationMember = async (organisationId, userId) => {
    const request = await createAxiosInstance();

    return request({
        url: `/organisation/member/remove`,
        method: 'POST',
        data: {
            organisation_id: organisationId,
            user_id: userId
        }
    })
}

export const getOrganisationUsage = async () => {
    const request = await createAxiosInstance();
    return request({
        url: `/organisation/usage/`,
        method: 'GET',
        data: {}
    });
}